import { ArrowForwardIos } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import i18n from '../../../i18n';
import { useAppPermissions } from '../../../services/appPermissions';
import { InternalContractDetail } from '../../BaseController/types/internalContract';
import { CustomButton } from '../../common/button/customButton';
import { ActiveCCRDialog } from './activeCCRDialog';

export interface ButtonContentProps {
  contractDetail: InternalContractDetail;
  buttonGroup?: string;
  hasActiveCCR?: boolean;
  setShowContactForm?: (showContactForm: boolean) => void;
}

export const ButtonContent = ({
  contractDetail,
  buttonGroup,
  hasActiveCCR,
  setShowContactForm,
}: ButtonContentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const [showActiveCCRDialog, setshowActiveCCRDialog] = useState(false);

  const {
    isLoading: isLoadingAppPermissions,
    appPermissions: apiDataAppPermissions,
  } = useAppPermissions();

  if (isLoadingAppPermissions) {
    return null;
  }

  const showActiveCCRPopup = () => {
    setshowActiveCCRDialog(true);
    // if (setShowContactForm) {
    //   setShowContactForm(true);
    // }
  };

  const handleAdjustEquipmentClick = () => {
    if (hasActiveCCR) {
      showActiveCCRPopup();
    } else {
      navigate(
        `/detail/${String(params.contractNumber)}/${String(
          params.contractPosition,
        )}/adjustEquipment`,
      );
    }
  };
  const handleEquipmentReturnClick = () => {
    if (hasActiveCCR) {
      showActiveCCRPopup();
    } else {
      navigate(
        `/detail/${String(params.contractNumber)}/${String(
          params.contractPosition,
        )}/returnEquipment`,
      );
    }
  };

  let buttons;
  if (apiDataAppPermissions) {
    const appPermissionsForApplication = apiDataAppPermissions.find(
      (e) => e.applicationId === process.env.REACT_APP_CIAM_APPLICATION_ID,
    );

    const appPermissionsOptions =
      appPermissionsForApplication?.applicationsOptions;

    const showAllowChangeRequest =
      appPermissionsOptions?.filter(
        (elem) => elem.optionid === 'allowChangeRequest' && elem.enabled,
      ).length === 1;

    if (contractDetail.contractType === 'RFM' && !buttonGroup) {
      buttons = (
        <>
          <CustomButton
            handleOnClick={() => {
              navigate(`/contracts`);
            }}
            text={t('ButtonContentBack')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid black',
            }}
            color="info"
          />

          <CustomButton
            handleOnClick={handleAdjustEquipmentClick}
            text={t('ButtonContentAdjustEquipment')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid transparent',
            }}
            color="secondary"
            endIcon={<ArrowForwardIos />}
            fullWidth
            visable={!!showAllowChangeRequest}
          />

          <CustomButton
            handleOnClick={handleEquipmentReturnClick}
            text={t('ButtonContentReturnEquipment')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid transparent',
            }}
            color="secondary"
            endIcon={<ArrowForwardIos />}
            fullWidth
            visable={!!showAllowChangeRequest}
          />

          <CustomButton
            handleOnClick={() => {
              const url = `${process.env.REACT_APP_RFM_SHOP_URL}/${i18n.language
                .toString()
                .substring(0, 2)}/search`;
              window.open(url, '_blank');
            }}
            text={t('ButtonContentReorderEquipment')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid transparent',
            }}
            color="primary"
            endIcon={<ArrowForwardIos />}
            fullWidth={!!showAllowChangeRequest}
          />
        </>
      );
    } else if (contractDetail.contractType === 'STR' && !buttonGroup) {
      buttons = (
        <>
          <CustomButton
            handleOnClick={() => {
              navigate(`/contracts`);
            }}
            text={t('ButtonContentBack')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid black',
            }}
            color="info"
          />

          <CustomButton
            handleOnClick={() => {
              if (setShowContactForm) setShowContactForm(true);
            }}
            text={t('ButtonContractChangeRequest')}
            sx={{
              fontFamily: 'JHFontBold',
              border: '1px solid transparent',
            }}
            color="secondary"
            endIcon={<ArrowForwardIos />}
          />
        </>
      );
    } else {
      switch (buttonGroup) {
        case 'returnEquipment':
          buttons = (
            <CustomButton
              handleOnClick={() => {
                navigate(
                  `/detail/${String(params.contractNumber)}/${String(
                    params.contractPosition,
                  )}`,
                );
              }}
              text={t('ButtonContentBack')}
              sx={{
                fontFamily: 'JHFontBold',
                border: '1px solid black',
              }}
              color="info"
            />
          );
          break;
        default:
          buttons = null;
      }
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <Stack direction="row" alignItems="flex-start" width="100%" spacing={2}>
        {buttons}
      </Stack>
      {setShowContactForm ? (
        <ActiveCCRDialog
          setShowContactForm={setShowContactForm}
          setshowActiveCCRDialog={setshowActiveCCRDialog}
          showActiveCCRDialog={showActiveCCRDialog}
        />
      ) : null}
    </div>
  );
};

ButtonContent.defaultProps = {
  buttonGroup: '',
  setShowContactForm: null,
  hasActiveCCR: false,
};
